import React from "react";
import { Box, CardMedia } from "@material-ui/core";
import { useTranslate } from "ra-core";
import ProcessingPreviewAlert from "./ProcessingPreviewAlert";
import { Alert } from "@material-ui/lab";



const Media = (props) => {
    const { noMargin = false, type, url, previewUrl, previewState } = props;
    const translate = useTranslate();
    const margin = noMargin ? 0 : 2;

    const getMediaUrl = () => {
        if (previewState == 'done') {
            return previewUrl;
        }
        return url;
    }

    if (previewState == 'enqueued') {
        return (
            <ProcessingPreviewAlert />
        );
    }
    if (type == 'audio') {
        return (
            <Box mt={margin} ml={margin} mr={margin}>
                <CardMedia
                    component='audio'
                    src={getMediaUrl()}
                    controls
                />
            </Box>
        );
    }
    if (type == 'image') {
        return (
            <Box style={{backgroundColor: '#000000'}}>
                <CardMedia
                    component='img'
                    src={getMediaUrl()}
                    controls
                    style={{
                        maxHeight: 'calc(90vh - 160px)',
                        margin: 'auto',
                        height: '100%',
                        width: '100%',
                        objectFit: 'scale-down',
                    }}
                />
            </Box>
        );
    }
    if (type == 'video') {
        return (
            <Box style={{backgroundColor: '#000000'}}>
                <CardMedia
                    component='video'
                    src={getMediaUrl()}
                    controls
                    style={{
                        maxHeight: 'calc(90vh - 160px)',
                        margin: 'auto',
                        height: '100%',
                        width: '100%',
                        objectFit: 'contain',
                    }}
                />
            </Box>
        );
    }
    return (
        <Box mt={margin} ml={margin} mr={margin}>
            <Alert severity="info">{ translate(`cmss.resources.file.no-available-preview`) }</Alert>
        </Box>
    );
}

export default Media;
